'use es6';

import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

var _Object$freeze;

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { memoize } from 'underscore';
import GoodFiltersAndPage from '../../constants/GoodFiltersAndPage';
import HubspotUrls from '../../constants/HubspotUrls';
import InitialFilterParams from '../../constants/InitialFilterParams';
import { getEnglishTextFieldFromTextsMap } from '../../utils/utils';
import FormattedMessage from 'I18n/components/FormattedMessage';
import EmailAddressPattern from 'PatternValidationJS/patterns/EmailAddress';
import UIRouterLink from 'ui-addon-react-router/UIRouterLink';
import UICardSection from 'UIComponents/card/UICardSection';
import UICardWrapper from 'UIComponents/card/UICardWrapper';
import HR from 'UIComponents/elements/HR';
import UIHelpIcon from 'UIComponents/icon/UIHelpIcon';
import UILink from 'UIComponents/link/UILink';
import UIDescriptionList from 'UIComponents/list/UIDescriptionList';
import UIList from 'UIComponents/list/UIList';
import PackCounts from 'marketplace-lib/components/goods/PackCounts';
import withPartials from 'marketplace-lib/components/hocs/withPartials';
import ModuleCompatibilityTagsList from 'marketplace-lib/components/list/ModuleCompatibilityTagsList';
import ModuleFunctionTagsList from 'marketplace-lib/components/list/ModuleFunctionTagsList';
import CertificationBadges from '../CertificationBadges';
import FilterRouterLink from '../FilterRouterLink';
import ExpandableThemeAssets from 'marketplace-lib/components/goods/ExpandableThemeAssets';
var getI18nKey = memoize(function (path) {
  return "MarketplaceUI.goodDetailsPage.info." + path;
});
var getTagI18nKey = memoize(function (tagType, tagName) {
  return "tagNames." + tagType + "." + tagName;
}, function (tagType, tagName) {
  return tagType + "-" + tagName;
});
var GoodTagKeys = Object.freeze((_Object$freeze = {}, _defineProperty(_Object$freeze, GoodFiltersAndPage.MODULE_PURPOSE, 'customModulePurposeTag'), _defineProperty(_Object$freeze, GoodFiltersAndPage.MODULE_COMPATIBILITY, 'customModuleCompatibilityTag'), _defineProperty(_Object$freeze, GoodFiltersAndPage.FEATURES, 'featureTags'), _defineProperty(_Object$freeze, GoodFiltersAndPage.INDUSTRY, 'industryTag'), _defineProperty(_Object$freeze, GoodFiltersAndPage.PAGE_LAYOUT, 'layoutTag'), _defineProperty(_Object$freeze, GoodFiltersAndPage.TEMPLATE_PURPOSE, 'templatePurposeTag'), _defineProperty(_Object$freeze, GoodFiltersAndPage.CODING_TYPE, 'codingType'), _Object$freeze));

var GoodInfoCard = /*#__PURE__*/function (_PureComponent) {
  _inherits(GoodInfoCard, _PureComponent);

  function GoodInfoCard(props) {
    var _this;

    _classCallCheck(this, GoodInfoCard);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(GoodInfoCard).call(this, props));
    _this.renderFilterLink = _this.renderFilterLink.bind(_assertThisInitialized(_this));
    _this.renderMultiselectFilterLink = _this.renderMultiselectFilterLink.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(GoodInfoCard, [{
    key: "renderFilterLink",
    value: function renderFilterLink(filters, linkText) {
      var _this$props = this.props,
          defaultFilters = _this$props.defaultFilters,
          previewMode = _this$props.previewMode;
      return React.createElement(FilterRouterLink, {
        key: JSON.stringify(filters),
        disabled: previewMode,
        filters: defaultFilters.merge(filters)
      }, linkText);
    }
  }, {
    key: "renderMultiselectFilterLink",
    value: function renderMultiselectFilterLink(filterType, _ref) {
      var tag = _ref.tag,
          tagTitle = _ref.tagTitle;

      var filters = _defineProperty({}, filterType, [tag]);

      return this.renderFilterLink(filters, tagTitle);
    }
  }, {
    key: "renderProductType",
    value: function renderProductType() {
      var goodDetails = this.props.goodDetails;

      var filter = _defineProperty({}, GoodFiltersAndPage.SUB_TYPE, goodDetails.get('subType'));

      return [React.createElement("dt", {
        key: "product-type-title"
      }, React.createElement(FormattedMessage, {
        message: getI18nKey('productType.title')
      })), React.createElement("dd", {
        key: "product-type-description"
      }, this.renderFilterLink(filter, React.createElement(FormattedMessage, {
        message: getI18nKey("productType.types." + goodDetails.get('subType'))
      })))];
    }
  }, {
    key: "renderDownloadsCount",
    value: function renderDownloadsCount() {
      var goodDetails = this.props.goodDetails;
      return [React.createElement("dt", {
        key: "downloads-title"
      }, React.createElement(FormattedMessage, {
        message: getI18nKey("downloads.title." + (goodDetails.get('isFree') ? 'installed' : 'purchased'))
      })), React.createElement("dd", {
        key: "downloads-description"
      }, React.createElement(FormattedMessage, {
        message: getI18nKey('downloads.count'),
        options: {
          count: goodDetails.get('downloads')
        }
      }))];
    }
  }, {
    key: "renderModuleFunctionTags",
    value: function renderModuleFunctionTags() {
      var _this$props2 = this.props,
          goodDetails = _this$props2.goodDetails,
          partial = _this$props2.partial;
      var tagKey = GoodTagKeys[GoodFiltersAndPage.MODULE_PURPOSE];
      var moduleFunctionTags = goodDetails.get(tagKey);

      if (!moduleFunctionTags.size) {
        return null;
      }

      return [React.createElement("dt", {
        key: tagKey + "-title"
      }, React.createElement(FormattedMessage, {
        message: getI18nKey(tagKey + ".title")
      })), React.createElement("dd", {
        key: tagKey + "-description"
      }, React.createElement(ModuleFunctionTagsList, {
        moduleFunctions: moduleFunctionTags.toArray(),
        tagComponent: partial(this.renderMultiselectFilterLink, GoodFiltersAndPage.MODULE_PURPOSE)
      }))];
    }
  }, {
    key: "renderModuleCompatibility",
    value: function renderModuleCompatibility() {
      var _this$props3 = this.props,
          goodDetails = _this$props3.goodDetails,
          partial = _this$props3.partial;
      var tagKey = GoodTagKeys[GoodFiltersAndPage.MODULE_COMPATIBILITY];
      var moduleCompatibilityTags = goodDetails.get(tagKey);

      if (!moduleCompatibilityTags.size) {
        return null;
      }

      return [React.createElement("dt", {
        key: tagKey + "-title"
      }, React.createElement(FormattedMessage, {
        message: getI18nKey(tagKey + ".title")
      })), React.createElement("dd", {
        key: tagKey + "-description"
      }, React.createElement(ModuleCompatibilityTagsList, {
        moduleCompatibility: moduleCompatibilityTags.toArray(),
        tagComponent: partial(this.renderMultiselectFilterLink, GoodFiltersAndPage.MODULE_COMPATIBILITY)
      }))];
    }
  }, {
    key: "renderParents",
    value: function renderParents() {
      var goodDetails = this.props.goodDetails;
      var parents = goodDetails.get('parents');

      if (!parents.size) {
        return null;
      }

      return [React.createElement("dt", {
        key: "parents-title"
      }, React.createElement(UIHelpIcon, {
        title: React.createElement(FormattedMessage, {
          message: getI18nKey('parents.help')
        })
      }, React.createElement(FormattedMessage, {
        message: getI18nKey('parents.title')
      }))), React.createElement("dd", {
        key: "parents-description"
      }, React.createElement(UIList, null, parents.map(function (parent) {
        return React.createElement(UIRouterLink, {
          key: parent.get('urlToken'),
          to: "products/" + parent.get('urlToken')
        }, getEnglishTextFieldFromTextsMap('NAME', parent.get('goodText')));
      })))];
    }
  }, {
    key: "renderPackCounts",
    value: function renderPackCounts() {
      var goodDetails = this.props.goodDetails;
      return [React.createElement("dt", {
        key: "pack-counts-title"
      }, React.createElement(FormattedMessage, {
        message: getI18nKey('packCounts.title'),
        options: {
          count: goodDetails.get('totalChildren')
        }
      })), React.createElement("dd", {
        key: "pack-counts-description"
      }, React.createElement(PackCounts, {
        packCounts: goodDetails.get('packCounts'),
        showHeader: false
      }))];
    }
  }, {
    key: "renderThemeAssets",
    value: function renderThemeAssets() {
      var goodDetails = this.props.goodDetails;
      return [React.createElement("dt", {
        key: "theme-assets-title"
      }, React.createElement(FormattedMessage, {
        message: getI18nKey('themeAssets.title')
      })), React.createElement("dd", {
        key: "theme-assets-description",
        className: "p-top-1 p-left-1"
      }, React.createElement(ExpandableThemeAssets, {
        assetNamesBySubType: goodDetails.get('assetNamesBySubType')
      }))];
    }
  }, {
    key: "renderTags",
    value: function renderTags(filterType) {
      var _this2 = this;

      var multi = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var goodDetails = this.props.goodDetails;
      var tagKey = GoodTagKeys[filterType];
      var tags = goodDetails.get(tagKey);

      if (!tags.size) {
        return null;
      }

      var tagsToRender = multi ? tags : [tags.get(0)];
      return [React.createElement("dt", {
        key: tagKey + "-title"
      }, React.createElement(FormattedMessage, {
        message: getI18nKey(tagKey + ".title")
      })), React.createElement("dd", {
        key: tagKey + "-description"
      }, React.createElement(UIList, null, tagsToRender.map(function (tag) {
        var tagFilter = _defineProperty({}, filterType, multi ? [tag] : tag);

        return _this2.renderFilterLink(tagFilter, React.createElement(FormattedMessage, {
          message: getTagI18nKey(tagKey, tag)
        }));
      })))];
    }
  }, {
    key: "renderDocumentationLink",
    value: function renderDocumentationLink() {
      var _this$props4 = this.props,
          goodDetails = _this$props4.goodDetails,
          previewMode = _this$props4.previewMode,
          trackLinkClick = _this$props4.trackLinkClick,
          partial = _this$props4.partial;
      var documentationLink = goodDetails.get('documentationLink');
      return documentationLink && React.createElement(UILink, {
        key: "documentation-link",
        disabled: previewMode,
        external: true,
        href: documentationLink,
        onClick: partial(trackLinkClick, 'documentation')
      }, React.createElement(FormattedMessage, {
        message: getI18nKey('resources.links.documentation')
      }));
    }
  }, {
    key: "renderResourceLinks",
    value: function renderResourceLinks() {
      var renderedResourceLinks = [this.renderDocumentationLink()].filter(Boolean);

      if (!renderedResourceLinks.length) {
        return null;
      }

      return renderedResourceLinks.length && [React.createElement("dt", {
        key: "resources-title"
      }, React.createElement(FormattedMessage, {
        message: getI18nKey('resources.title')
      })), React.createElement("dd", {
        key: "resources-description"
      }, React.createElement(UIList, null, renderedResourceLinks))];
    }
  }, {
    key: "renderProviderInfo",
    value: function renderProviderInfo() {
      var _this$props5 = this.props,
          goodDetails = _this$props5.goodDetails,
          previewMode = _this$props5.previewMode,
          trackLinkClick = _this$props5.trackLinkClick,
          partial = _this$props5.partial;
      var contactEmail = goodDetails.get('contactEmail');
      var contactLink = null;

      if (contactEmail) {
        contactLink = EmailAddressPattern.test(contactEmail) ? "mailto:" + contactEmail : contactEmail;
      }

      return [React.createElement("dt", {
        key: "provider-info-title"
      }, React.createElement(FormattedMessage, {
        message: getI18nKey('provider.title')
      })), React.createElement("dd", {
        key: "provider-info-description"
      }, React.createElement(UIList, null, goodDetails.get('providerName'), React.createElement(FilterRouterLink, {
        disabled: previewMode,
        filters: InitialFilterParams.merge(_defineProperty({}, GoodFiltersAndPage.PROVIDER, goodDetails.get('providerName')))
      }, React.createElement(FormattedMessage, {
        message: getI18nKey('provider.links.products')
      })), React.createElement(UILink, {
        disabled: previewMode,
        external: true,
        href: goodDetails.get('providerWebsite'),
        onClick: partial(trackLinkClick, 'providerWebsite')
      }, React.createElement(FormattedMessage, {
        message: getI18nKey('provider.links.website')
      })), contactLink && React.createElement(UILink, {
        disabled: previewMode,
        external: true,
        href: contactLink,
        onClick: partial(trackLinkClick, 'email')
      }, React.createElement(FormattedMessage, {
        message: getI18nKey('provider.links.email')
      }))))];
    }
  }, {
    key: "renderCertifications",
    value: function renderCertifications() {
      var _this$props6 = this.props,
          goodDetails = _this$props6.goodDetails,
          previewMode = _this$props6.previewMode,
          trackLinkClick = _this$props6.trackLinkClick,
          partial = _this$props6.partial;
      var certifications = goodDetails.get('certifications');
      return [React.createElement("dt", {
        key: "certifications-title"
      }, React.createElement(FormattedMessage, {
        message: getI18nKey('certifications.title')
      })), React.createElement("dd", {
        key: "certifications-description"
      }, React.createElement(CertificationBadges, {
        certifications: certifications
      }), React.createElement(UILink, {
        disabled: previewMode,
        external: true,
        href: HubspotUrls.CERTIFICATION_OVERVIEW,
        onClick: partial(trackLinkClick, 'certifications')
      }, React.createElement(FormattedMessage, {
        message: getI18nKey('learnMore')
      })))];
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props7 = this.props,
          isCustomModule = _this$props7.isCustomModule,
          isEmailTemplate = _this$props7.isEmailTemplate,
          isPack = _this$props7.isPack,
          isTemplate = _this$props7.isTemplate,
          isTheme = _this$props7.isTheme;
      return React.createElement(UICardWrapper, {
        className: "m-bottom-0",
        compact: true
      }, React.createElement(UICardSection, null, React.createElement(UIDescriptionList, null, this.renderProductType(), this.renderDownloadsCount(), isCustomModule && this.renderModuleFunctionTags(), isCustomModule && this.renderModuleCompatibility(), this.renderParents(), isPack && this.renderPackCounts(), isTheme && this.renderThemeAssets(), this.renderTags(GoodFiltersAndPage.FEATURES), this.renderTags(GoodFiltersAndPage.INDUSTRY, false), isTemplate && this.renderTags(GoodFiltersAndPage.PAGE_LAYOUT, false), isTemplate && this.renderTags(GoodFiltersAndPage.TEMPLATE_PURPOSE, false), isEmailTemplate && this.renderTags(GoodFiltersAndPage.CODING_TYPE), this.renderResourceLinks(), React.createElement(HR, null), this.renderProviderInfo(), this.renderCertifications())));
    }
  }]);

  return GoodInfoCard;
}(PureComponent);

GoodInfoCard.propTypes = {
  defaultFilters: PropTypes.instanceOf(Immutable.Map).isRequired,
  goodDetails: PropTypes.instanceOf(Immutable.Map).isRequired,
  isCustomModule: PropTypes.bool.isRequired,
  isEmailTemplate: PropTypes.bool.isRequired,
  isPack: PropTypes.bool.isRequired,
  isTemplate: PropTypes.bool.isRequired,
  isTheme: PropTypes.bool.isRequired,
  partial: PropTypes.func.isRequired,
  previewMode: PropTypes.bool.isRequired,
  trackLinkClick: PropTypes.func.isRequired
};
GoodInfoCard.defaultProps = {
  defaultFilters: Immutable.Map()
};
export default withPartials(GoodInfoCard);